/*
 * Hair Labs — entrance reveal system (v10.0)
 * Reveals elements with class `hl-reveal` as they enter the viewport, using one
 * shared choreography (tokens in assets/hl-tokens.css).
 *
 * Safety contract: this is a pure enhancement. The inline head script installs a
 * failsafe that force-reveals everything if this file ever fails to run, and the
 * reduced-motion / no-IntersectionObserver paths reveal immediately. Content is
 * never kept hidden behind JavaScript.
 */
(function () {
  'use strict';

  if (window.__hlRevealReady) return;
  window.__hlRevealReady = true;

  var docEl = document.documentElement;
  docEl.classList.add('js');

  function revealAll() {
    docEl.classList.add('hl-reveal-failsafe');
  }

  function init() {
    var nodes = document.querySelectorAll('.hl-reveal:not(.is-in)');
    if (!nodes.length) return;

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach(function (n) {
      io.observe(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-scan when sections are (re)rendered in the theme editor or injected.
  document.addEventListener('shopify:section:load', init);
})();
